<!-- 创建终端弹窗（浅色后台风，顶部横向步骤，交互逻辑与注册页一致） -->
<template>
  <div>
    <el-dialog
      custom-class="terminal-dialog"
      :visible.sync="showDialog"
      :title="$t('text.cjzdyh')"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
      append-to-body
      @opened="handleOpened"
      @closed="resetForm"
    >
      <!-- 左导航 + 右表单 -->
      <div class="wizard-wrap">
        <!-- 左侧步骤导航 -->
        <aside class="side-nav">
          <ul class="side-nav-list">
            <li
              v-for="(title, index) in wizardSteps"
              :key="index"
              class="side-nav-item"
              :class="[active === index ? 'is-active' : '', active > index ? 'is-done' : '']"
            >
              <span class="nav-dot">
                <i v-if="active > index" class="el-icon-check" />
                <b v-else>{{ index + 1 }}</b>
              </span>
              <span class="nav-text">{{ title }}</span>
            </li>
          </ul>
        </aside>
        <!-- 右侧表单 -->
        <div class="wizard-content">
          <el-scrollbar style="height:100%">
            <!-- step1 用户信息 -->
            <div v-if="active === 0" key="1" class="step-pane">
              <el-form ref="step1" :model="formUser" :rules="step1Rule" label-position="right" label-width="120px">
                <el-form-item :label="$t('text.yhm')" prop="username">
                  <el-input v-model="formUser.username" clearable />
                </el-form-item>
                <el-form-item :label="$t('text.mm')" prop="pwd">
                  <el-input v-model="formUser.pwd" show-password />
                </el-form-item>
                <el-form-item :label="$t('text.qrmm')" prop="pwdconfirm">
                  <el-input v-model="formUser.pwdconfirm" show-password />
                </el-form-item>
                <div class="btn-area">
                  <el-button type="primary" @click="step1()">{{ $t('button.xyb') }}</el-button>
                </div>
              </el-form>
            </div>

            <!-- step2 电站信息 -->
            <div v-if="active === 1" key="2" class="step-pane">
              <el-form ref="step2" :model="formStation" :rules="step2Rule" label-position="right" label-width="180px">
                <!-- 电站图片 -->
                <el-form-item label="电站图片">
                  <img-upload ref="imgRef" v-model="formStation.img" />
                  <span style="color: var(--primary-color);">仅支持jpg、jpeg、png格式</span>
                </el-form-item>
                <el-form-item :label="$t('text.dzlx')" prop="orgtype">
                  <el-select v-model="formStation.orgtype" clearable placeholder="请选择电站类型" @change="orgtypeChange">
                    <el-option v-for="item in orgtype" :key="item.value" :label="$t(item.label)" :value="item.value" />
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('text.zdmc')" prop="orgname">
                  <el-input v-model="formStation.orgname" clearable />
                </el-form-item>
                <el-form-item :label="$t('text.stationBelongProvince')" prop="province">
                  <el-select v-model="formStation.province" clearable filterable>
                    <el-option v-for="item in provinceOptions" :key="item.value" :label="item.key" :value="item.value" />
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('text.stationTimezone')" prop="tzonecode">
                  <el-select v-model="formStation.tzonecode" clearable>
                    <el-option
                      v-for="(item, index) in timeOptions"
                      :key="index"
                      :label="item.key"
                      :value="item.value + ''"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item v-if="formStation.orgtype !== '2' && formStation.orgtype !== '4'" prop="capacity" label="装机容量【单位:kWp】">
                  <el-input-number v-model="formStation.capacity" :min="1" :step="0.1" controls-position="right" :precision="2" style="margin-top: 0;" />
                </el-form-item>
                <div class="btn-area">
                  <el-button @click="active = 0">{{ $t('button.syb') }}</el-button>
                  <el-button type="primary" @click="step2()">{{ $t('button.xyb') }}</el-button>
                </div>
              </el-form>
            </div>

            <!-- step3 设备列表 -->
            <div v-if="active === 2" key="3" class="step-pane">
              <div class="collector-panel">
                <div class="collector-input-row">
                  <el-input v-model="collectorInput" :placeholder="$t('msg.qsrsn')" clearable @keyup.enter.native="addCollector" />
                  <el-button type="primary" @click="addCollector">{{ $t('button.tianjia') }}</el-button>
                </div>
                <div v-if="formDeviceList.length" class="collector-list">
                  <span v-for="(sn, index) in formDeviceList" :key="sn" class="collector-chip">
                    <i class="el-icon-connection chip-icon" />
                    <span class="chip-text">{{ sn }}</span>
                    <i class="el-icon-close chip-close" @click="removeCollector(index)" />
                  </span>
                </div>
                <div v-else class="collector-empty">
                  <i class="el-icon-information" />
                  <span>{{ $t('text.collectorListTip') }}</span>
                </div>
              </div>
              <div class="btn-area">
                <el-button @click="active = 1">{{ $t('button.syb') }}</el-button>
                <el-button type="primary" :loading="submitLoading" @click="CreateTerminal">{{ $t('button.cj') }}</el-button>
              </div>
            </div>
          </el-scrollbar>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ImgUpload from '@views/Imgupload'
import { GetAddresses, GetTimeZones } from '@apis/Universal'
import { CreateStationByInstaller } from '@/api/Stations'

const stationImagePath = `${process.env.VUE_APP_BASE_API}/imgs/stations`
export default {
  components: {
    ImgUpload
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const validPwdconfirm = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('placeholder.qzcsr')))
      } else if (value !== this.formUser.pwd) {
        callback(new Error(this.$t('notice.mmbyz')))
      } else {
        callback()
      }
    }
    return {
      active: 0,
      timeOptions: [],
      orgtype: [
        { label: 'text.zc', value: '0' },
        { label: 'text.cn', value: '1' },
        { label: 'text.qx', value: '2' },
        { label: 'text.db', value: '3' },
        { label: 'text.orgtype_switch', value: '4' }
      ],
      provinceOptions: [],
      // 步骤1：账号信息
      formUser: {
        username: '',
        pwd: '',
        pwdconfirm: ''
      },
      // 步骤2：电站信息
      formStation: {
        img: `${stationImagePath}/default.png`,
        orgtype: '',
        orgname: '',
        capacity: '',
        province: '',
        tzonecode: '101'
      },
      // 步骤3：设备列表（采集器SN）
      formDeviceList: [],
      // 第3步：采集器编号输入框
      collectorInput: '',
      step1Rule: {
        username: [
          { required: true, message: this.$t('msg.sryhm'), trigger: 'blur' },
          { min: 2, message: this.$t('msg.zslwyhm'), trigger: 'blur' },
        ],
        pwd: [
          { required: true, message: this.$t('msg.srmm'), trigger: 'blur' },
          { min: 6, max: 20, message: this.$t('msg.qsrmm'), trigger: 'blur' },
        ],
        pwdconfirm: [
          { required: true, message: this.$t('msg.qzcsrmm') },
          { validator: validPwdconfirm, trigger: 'blur' }
        ],
      },
      step2Rule: {
        orgtype: [
          { required: true, message: this.$t('msg.xzdzlx'), trigger: 'change' }
        ],
        orgname: [
          { required: true, message: this.$t('msg.qsrzdmc'), trigger: 'blur' }
        ],
        province: [
          { required: true, message: this.$t('msg.qsrsf'), trigger: 'change' }
        ],
        tzonecode: [
          { required: true, message: this.$t('msg.qsrsq'), trigger: 'change' }
        ]
      },
      // 提交按钮loading状态
      submitLoading: false
    }
  },
  computed: {
    // 三个步骤标题（跟随语言切换）
    wizardSteps () {
      return [
        this.$t('text.yhxx'),
        this.$t('text.zdxx'),
        this.$t('text.deviceList')
      ]
    }
  },
  methods: {

    /** 弹窗打开时触发 */
    handleOpened () {
      this.getTimeZoneAndProvince()
    },

    /** 关闭弹窗 */
    handleClose () {
      this.$emit('update:showDialog', false)
    },
    /** 第一步 下一步按钮 */
    step1 () {
      this.$refs.step1.validate((valid) => {
        if (valid) {
          this.active = 1
        }
      })
    },
    /** 第二步 下一步按钮 */
    step2 () {
      this.$refs.step2.validate((valid) => {
        if (valid) {
          this.active = 2
        }
      })
    },
    /** 获取时区和省份 */
    getTimeZoneAndProvince () {
      if (this.timeOptions.length === 0 || this.provinceOptions.length === 0) {
        Promise.all([GetTimeZones({ id: '' }), GetAddresses({ id: '44' })]).then(res => {
          this.timeOptions = { ...res[0].data }
          this.provinceOptions = res[1].data
        })
      }
    },
    /** 电站类型切换 */
    orgtypeChange () {
      this.formDeviceList = []
    },
    /** 添加采集器编号 */
    addCollector () {
      const sn = (this.collectorInput || '').trim()
      if (!sn) {
        this.$msgError(this.$t('msg.qsrsn'))
        return
      }
      if (this.formDeviceList.includes(sn)) {
        this.$msgError(this.$t('notice.bycfsr'))
        return
      }
      this.formDeviceList.push(sn)
      this.collectorInput = ''
    },
    /** 移除采集器编号 */
    removeCollector (index) {
      this.formDeviceList.splice(index, 1)
    },
    /** 设备列表校验 */
    validateDeviceList () {
      if (!Array.isArray(this.formDeviceList) || this.formDeviceList.length === 0) {
        this.$msgError(this.$t('msg.qsrsn'))
        return false
      }
      return true
    },
    /** 组装提交参数 */
    getPostData () {
      const user = {
        userName: this.formUser.username,
        password: this.formUser.pwd,
        passwordConfirm: this.formUser.pwdconfirm,
      }
      const station = {
        image: this.formStation.img,
        stationType: this.formStation.orgtype,
        stationName: this.formStation.orgname,
        stationProvinceCode: this.formStation.province,
        stationTimezoneCode: this.formStation.tzonecode,
        installedCapacity: this.formStation.capacity,
      }
      if (station.image.indexOf('base64') === -1) {
        station.image = null
      }
      return {
        user,
        station,
        gatewaySnList: this.formDeviceList
      }
    },
    /** 重置表单 */
    resetForm () {
      if (this.$refs.step1 && this.$refs.step2) {
        this.$refs.step1.resetFields()
      }
      if (this.$refs.step2) {
        this.$refs.step2.resetFields()
      }
      this.formDeviceList = []
    },
    /** 创建终端用户 */
    CreateTerminal () {
      if (!this.validateDeviceList()) {
        return
      }
      const postData = this.getPostData()
      this.submitLoading = true
      CreateStationByInstaller(postData).then(() => {
        this.submitLoading = false
        this.$message({
          message: '创建成功',
          type: 'success'
        })
        this.handleClose()
      }).catch(() => {
        this.submitLoading = false
        this.$message({
          message: '创建失败',
          type: 'error'
        })
      })
    }
  }
}
</script>
<style>
@import './createterminal.css';
</style>
